import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { XIcon } from 'lucide-react';
const product = 'Atlas Visual de Instrumentación Quirúrgica';
const notices = [{
  name: 'Camila R.',
  city: 'Guadalajara, México',
  product
}, {
  name: 'Nicolás B.',
  city: 'Medellín, Colombia',
  product
}, {
  name: 'Sofía D.',
  city: 'Lima, Perú',
  product
}, {
  name: 'Andrés V.',
  city: 'Santiago, Chile',
  product
}, {
  name: 'Valeria P.',
  city: 'Quito, Ecuador',
  product
}, {
  name: 'Mateo G.',
  city: 'Córdoba, Argentina',
  product
}];
export function PurchaseToast() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    const show = window.setTimeout(() => setVisible(true), 6000);
    return () => window.clearTimeout(show);
  }, [dismissed]);
  useEffect(() => {
    if (!visible || dismissed) return;
    const hide = window.setTimeout(() => setVisible(false), 7000);
    const next = window.setTimeout(() => {
      setIndex(current => (current + 1) % notices.length);
      setVisible(true);
    }, 22000);
    return () => {
      window.clearTimeout(hide);
      window.clearTimeout(next);
    };
  }, [visible, index, dismissed]);
  const notice = notices[index];
  return <div className="pointer-events-none fixed bottom-4 left-4 z-40 max-w-[calc(100vw-2rem)]" data-id="element-202" data-mp="285hfk3opnr0a">
      <AnimatePresence data-id="element-203" data-mp="1bhkwms5swjlw">
        {visible && !dismissed && <motion.aside initial={{
        opacity: 0,
        y: 12,
        scale: 0.98
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 12,
        scale: 0.98
      }} transition={{
        duration: 0.24,
        ease: [0.23, 1, 0.32, 1]
      }} aria-live="polite" className="pointer-events-auto flex w-[19rem] items-start gap-3 rounded-xl bg-white p-4 shadow-lg ring-1 ring-gray-200" data-id="element-204" data-mp="1fgtotsl709fc">
            <div className="min-w-0 flex-1" data-id="element-205" data-mp="wpj1tmil8gsq">
              <p className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-wider text-emerald-700" data-id="element-206" data-mp="201rfpi641ke0">
                <span className="h-2 w-2 rounded-full bg-emerald-500" aria-hidden="true" data-id="element-207" data-mp="1v3pw8w4rvj20" />
                Compra verificada
              </p>
              <p className="mt-2 text-sm font-bold text-gray-900" data-id="element-208" data-mp="28tjprrr82ri2">
                {notice.name} de {notice.city}
              </p>
              <p className="truncate text-sm text-gray-600" data-id="element-209" data-mp="1h2vngcdtbg2t">
                Compró <span className="font-semibold text-blue-700" data-id="element-210" data-mp="1h59fsdh3ye6o">{notice.product}</span>
              </p>
              <p className="mt-1 text-xs text-gray-400" data-id="element-211" data-mp="1c659pvphcwkk">hace 2 minutos</p>
            </div>
            <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar aviso" className="rounded-md p-1 text-gray-400 transition-colors duration-150 ease-out hover:bg-gray-100 hover:text-gray-700 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-blue-300" data-id="element-212" data-mp="1q54xl15657fo">
              <XIcon className="h-4 w-4" aria-hidden="true" data-id="element-213" data-mp="350oa0jzvd4mt" />
            </button>
          </motion.aside>}
      </AnimatePresence>
    </div>;
}